import { useDisclosure } from "@mantine/hooks";
import { OrganizationsModel } from "../../model/OrganizationsModel";
import { useEffect, useState } from "react";
import Repository from "../../_base/helper/HttpHelper";
import { MessageResponse } from "../../model/MessageResponse";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { useForm } from "@mantine/form";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  LoadingOverlay,
  Select,
  Textarea,
  TextInput,
} from "@mantine/core";
import { getBranchSelect, getDepartmentSelect } from "../../const/getSelectApi";
import { IconWindow, IconCheck } from "@tabler/icons-react";
import { repositorySign } from "../../_base/_const/_constVar";
import { SelectListItem } from "../../_base/model/_base/SelectListItemBase";
import { TblDepartmentModel } from "../../model/TblDepartmentModel";

const OrganizationEditView = ({ onClose, id }: OrganizationCreateEditProps) => {
  const entity: TblDepartmentModel = {
    id: id,
    code: "",
    name: "",
    address: "",
  };

  const [dataBranch, setDataBranch] = useState<SelectListItem[]>([]);

  const [visible, { close, open }] = useDisclosure(false);

  async function getBranch() {
    const data = await getDepartmentSelect();
    if (data && data.length > 0) setDataBranch(data);
  }

  const form = useForm<TblDepartmentModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    transformValues: (values) => ({
      ...values,
    }),
    validate: {
      name: (value) => {
        if (!value) return "Tên không được để trống";
        return null;
      },
      code: (value) => {
        if (!value) return "Mã phòng ban không được để trống";
        return null;
      },
    },
  });

  const handleSetEntity = async () => {
    let url = "/api/v1/Department/update?id=" + id;
    let callApi = await repositorySign.get<MessageResponse<TblDepartmentModel>>(
      url
    );
    if (callApi?.success) {
      form.initialize(callApi.data);
      if (callApi.data.type)
        form.setFieldValue("type", callApi.data.type.toString());
      if (callApi.data.parentId)
        form.setFieldValue("parentId", callApi.data.parentId.toString());
    } else {
      NotificationExtension.Fails("Lỗi !");
    }
  };

  const handleCreateDepartment = async (payload: TblDepartmentModel) => {
    open();
    let url = "/api/v1/Department/update";
    let callApi = await repositorySign.post<MessageResponse<boolean>>(
      url,
      payload
    );
    if (callApi?.httpStatusCode === 200) {
      if (callApi?.success) {
        await onClose();
        modals.closeAll();
        NotificationExtension.Success("Thành công !");
      } else NotificationExtension.Fails("Thất bại !");
    }

    close();
  };

  useEffect(() => {
    handleSetEntity();
    getBranch();
  }, []);

  const typeOptions = [
    { value: 1, text: "Công ty mẹ", color: "blue" },
    { value: 3, text: "Phòng ban", color: "green" },
    { value: 2, text: "Đơn vị thành viên", color: "orange" },
  ];

  return (
    <>
      <Box
        component="form"
        mx="auto"
        onSubmit={form.onSubmit((e: TblDepartmentModel) => {
          handleCreateDepartment(e);
        })}
        style={{
          position: "relative",
          width: "500px",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        ></LoadingOverlay>

        <Grid>
          <Grid.Col span={12}>
            <TextInput
              key={form.key("code")}
              label="Mã phòng ban"
              withAsterisk
              placeholder="Nhập mã phòng ban"
              {...form.getInputProps("code")}
            ></TextInput>
          </Grid.Col>

          <Grid.Col span={12}>
            <TextInput
              key={form.key("name")}
              label="Tên phòng ban"
              withAsterisk
              placeholder="Nhập tên phòng ban"
              {...form.getInputProps("name")}
            ></TextInput>
          </Grid.Col>
          <Grid.Col span={12}>
            <Select
              id="type"
              key={form.key("type")}
              label="Loại đơn vị/phòng ban"
              placeholder="Đơn vị cấp cha..."
              data={typeOptions?.map((item) => {
                return {
                  label: item.text,
                  value: item.value.toString(),
                };
              })}
              nothingFoundMessage="Không có dữ liệu"
              searchable
              clearable
              {...form.getInputProps("type")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Select
              id="parentId"
              key={form.key("parentId")}
              label="Đơn vị cấp cha"
              placeholder="Đơn vị cấp cha..."
              data={dataBranch?.map((item) => {
                return {
                  label: item.text,
                  value: item.value,
                };
              })}
              nothingFoundMessage="Không có dữ liệu"
              searchable
              clearable
              {...form.getInputProps("parentId")}
            />
          </Grid.Col>

          <Grid.Col span={12}>
            <TextInput
              key={form.key("address")}
              label="Địa chỉ"
              placeholder="Địa chỉ"
              {...form.getInputProps("address")}
            ></TextInput>
          </Grid.Col>

          <Grid.Col span={12}>
            <Checkbox
              label="Hoạt động"
              key={form.key("status")}
              {...form.getInputProps("status", { type: "checkbox" })}
            ></Checkbox>
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col
            span={12}
            display={"flex"}
            style={{ justifyContent: "flex-end", gap: "30px" }}
          >
            <Button
              type="button"
              color="gray"
              loading={visible}
              onClick={() => {
                modals.closeAll();
              }}
              leftSection={!visible ? <IconWindow size={18} /> : undefined}
            >
              Đóng
            </Button>
            <Button
              type="submit"
              color="blue"
              loading={visible}
              leftSection={!visible ? <IconCheck size={18} /> : undefined}
            >
              Lưu
            </Button>
          </Grid.Col>
        </Grid>
      </Box>
    </>
  );
};

type OrganizationCreateEditProps = {
  onClose: any;
  id: number;
};

export default OrganizationEditView;
